import { activate } from '../reducers/messages';

export default function(store, action) {
  const { dispatch } = store;

  setTimeout(() => dispatch(activate(action.id)), 250);
}
